var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{attrs:{"id":"limit"}},[_c('i',{staticClass:"fas fa-triangle-exclamation"}),_vm._v(" "),_c('b-container',{staticClass:"px-md-0"},[_c('b-row',[_c('b-col',{attrs:{"md":"8"}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.$t('limit.desc'))}})])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }